<template>
  <div id="app">
    <the-header />
    <div class="content-holder">
      <transition name="component-fade" mode="out-in">
        <the-form v-if="currentStatus === 0" />
        <success v-else-if="currentStatus === 1" />
        <error v-else />
      </transition>
    </div>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheForm from '@/components/TheForm.vue'
import Success from '@/components/Success.vue'
import Error from '@/components/Error.vue'

export default {
  components: {
    TheHeader,
    TheForm,
    Success,
    Error
  },
  computed: {
    currentStatus () {
      return this.$store.getters.currentStatus
    }
  }
}
</script>

<style lang="scss">
  @import url('./assets/fonts/fonts.css');
  body {
    background: #fff;
    overflow-x: hidden;
  }
  #app {
    max-width: 840px;
    width: 100%;
    margin: 0 auto;
  }
  .content-holder {
    margin-right: 70px;
    margin-left: 70px;
    margin-top: 50px;
    margin-bottom: 75px;
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: all 0.3s ease-out;
    transform: translateX(0);
    opacity: 1;
  }
  .component-fade-leave-to
  /* .component-fade-leave-active до версии 2.1.8 */ {
    transform: translateX(-100%);
    opacity: 0;
  }

  .component-fade-enter
  /* .component-fade-leave-active до версии 2.1.8 */ {
    transform: translateX(100%);
    opacity: 0;
  }
  @media only screen and (max-width: 768px) {
    .content-holder {
      margin-right: 20px;
      margin-left: 20px;
      margin-top: 50px;
    }
  }
</style>
